import { NumberSettingsPage } from '@/views/number-settings/number-settings-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const MissedCallTab = z.enum(['voicemail', 'ai_receptionist', 'transfer']);

export const Route = createFileRoute('/_app/settings/numbers/$number')({
  component: RouteComponent,
  // missedCallTab lets external links (notably global search) deep-link the missed-call
  // section to a specific tab. The section reads it via Route.useSearch and uses it as the
  // initial activeTab.
  validateSearch: z.object({
    missedCallTab: MissedCallTab.optional(),
  }),
});

function RouteComponent() {
  const { number } = Route.useParams();
  const { missedCallTab } = Route.useSearch();
  return <NumberSettingsPage number={number} initialMissedCallTab={missedCallTab} />;
}
